<div class="main-content py-2 px-0 px-lg-2">
  <div class="section-menu-items">
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['manage-admin-funds']"
      routerLinkActive="router-link-active"
      *hideIfUnauthorized="'manage funds - retailer/salesRep'"
    >
    <span translate class="translate">pages.newRetailer.manageFunds</span> <mat-icon class="ms-2">price_change</mat-icon>
    </button>
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['credit-line-report']"
      routerLinkActive="router-link-active"
      *hideIfUnauthorized="'Credit Line Report'"
    >
    <span translate class="translate">pages.newRetailer.creditLineReport</span><mat-icon class="ms-2">request_quote</mat-icon>
    </button>
    <button
      mat-flat-button
      [routerLink]="['add-money']"
      class="item-each"
      routerLinkActive="router-link-active"
      *hideIfUnauthorized="'add Money - retailer/salesRep'"
    >
    <span translate class="translate">pages.newRetailer.autoReload</span><mat-icon class="ms-2">payments</mat-icon>
    </button>
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['manage-retailer-funds']"
      routerLinkActive="router-link-active"
      *hideIfUnauthorized="'manage funds - admin'"
    >
    <span translate class="translate">pages.newRetailer.manageFunds</span><mat-icon class="ms-2">price_change</mat-icon>
    </button>
  </div>

  <router-outlet></router-outlet>
</div>
